var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.055,
    height: 34.85,
    viewBox: "0 0 35.055 34.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5906",
    "data-name": "Group 5906",
    transform: "translate(5.06 -69.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spericorn-black-logo",
    transform: "translate(-5.06 69.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6457",
    "data-name": "Group 6457",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6456",
    "data-name": "Group 6456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    d: "M129.884,76.178a17.258,17.258,0,0,0-12.521,5.085,16.619,16.619,0,0,0-5.171,12.2,16.909,16.909,0,0,0,5.171,12.47,17.243,17.243,0,0,0,12.521,5.085A17.4,17.4,0,0,0,147.242,93.8a17.182,17.182,0,0,0-5.09-12.452A16.693,16.693,0,0,0,129.884,76.178Zm-6.4,10.977a8.746,8.746,0,0,1,6.4-2.59,8.124,8.124,0,0,1,6.13,2.655A9.092,9.092,0,0,1,138.58,93.8a8.508,8.508,0,0,1-2.59,6.2,8.04,8.04,0,0,1-5.973,2.646,8.943,8.943,0,0,1-9.168-8.714q0-.229,0-.458A8.4,8.4,0,0,1,123.486,87.155Z",
    transform: "translate(-112.189 -76.175)",
    fill: "#06b2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    d: "M132.111,89.652a6.382,6.382,0,1,1-6.382-6.382h0A6.383,6.383,0,0,1,132.111,89.652Z",
    transform: "translate(-108.206 -72.227)",
    fill: "#ffffff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.982df6a267396a91fa34ad1faa540085.svg";
export { ForwardRef as ReactComponent };